import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="url-share"
export default class extends Controller {
  static targets = [ 'message' ]

  connect() {
  }

  copyUrl(event) {
    event.preventDefault()
    navigator.clipboard.writeText(this.element.dataset.url)
      .then(() => {
        this.#showMessage()
      })
      .catch((err) => {
        console.error("Failed to copy URL:", err)
      })
  }

  #showMessage() {
    this.messageTarget.classList.remove("d-none")

    // 2秒後にメッセージを非表示にする場合
    setTimeout(() => {
      this.messageTarget.classList.add("d-none")
    }, 2000)
  }
}
